import AuthCredentials from "@/features/auth/models/auth.models";
import ApiService from "@/services/api.service";

const AuthService = {
  login: async function (authCredentials: AuthCredentials) {
    return ApiService.post("/v1.9/account/login", authCredentials);
  },
  logout: async function () {
    return ApiService.post("/v1.9/account/logout", {});
  },
};

export default AuthService;
